<template>
<div :class="$style.searches">
    <div :class="$style.title">
        {{label('quick_search')}}
    </div>

    <template v-if="allowDealerCode && dealerCodes">
        <!-- <dropDown :label="label('dealerCodes')" :class="$style.dropDown" v-on:selection="selection" :reset="resetTrigger.dealerCode" :name="'dealerCode'" :items="list_dealer_codes"/> -->
        <DealerCode :dealerCodes="dealerCodes" v-on:selection="selectedDealerCode"/>
    </template>

    <div>
        <span :class="$style.label">Keyword</span>
        <input type="text" v-model="searches.keyword" :class="$style.keyword"> 
    </div>

    <!-- <dropDown :label="label('reportCode')" :class="$style.dropDown" v-on:selection="selection" :reset="resetTrigger.reportCode" :name="'reportCode'" :items="list_report_codes"/> -->


    <dropDown nodeId="report-id-select" :label="label('reportId')" :class="$style.dropDown" v-on:selection="selection" :reset="resetTrigger.reportId" :name="'reportId'" :items="list_report_names"/>


    <dropDown nodeId="report-type-select" :label="label('reportTypeId')" :class="$style.dropDown"  v-on:selection="selection" :reset="resetTrigger.reportTypeId" :name="'reportTypeId'" :items="list_report_types"/>


    <dropDown nodeId="frequency-select" :label="label('reportFrequencyId')" :class="$style.dropDown" v-on:selection="selection" :reset="resetTrigger.reportFrequencyId" :name="'reportFrequencyId'" :items="list_report_frequencies"/>


    <fieldset>
        <legend>{{label('date_range')}}</legend>
        <center>
            <datepicker v-model="searches.startDate" v-on:selected="dateChange('startDate')" :disabled-dates="disabledStartDate()" :language="calendarLang"></datepicker> - 
            <datepicker v-model="searches.endDate" v-on:selected="dateChange('endDate')" :disabled-dates="disabledEndDate()" :language="calendarLang"></datepicker>

            <div :class="$style.dateButtons">
                <button v-bind:class="{ [$style.active]:(daysAgo==0) }" v-on:click="selectDaysInPast(0)">{{ 'today' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==1) }" v-on:click="selectDaysInPast(1)">{{ 'oneDayAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==2) }" v-on:click="selectDaysInPast(2)">{{ 'twoDaysAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==3) }" v-on:click="selectDaysInPast(3)">{{ 'threeDaysAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==4) }" v-on:click="selectDaysInPast(4)">{{ 'fourDaysAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==5) }" v-on:click="selectDaysInPast(5)">{{ 'fiveDaysAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==6) }" v-on:click="selectDaysInPast(6)">{{ 'sixDaysAgo' | str }}</button>
                <button v-bind:class="{ [$style.active]:(daysAgo==7) }" v-on:click="selectDaysInPast(7)">{{ 'sevenDaysAgo' | str }}</button>
            </div>

        </center>
    </fieldset>

    <div :class="$style.buttons">
        <transition name="fade">
            <button v-if="ready_to_search" class="big primary" style="position:absolute; left: 5px;" @click="applySearch">
                <i class="fas fa-search"></i>
                {{label('search')}}
            </button>
        </transition>
        <button class="big" style="position:absolute; right: 5px;" @click="resetSearch()">
            <i class="fas fa-sync-alt"></i>
            {{label('reset')}}
        </button>        
    </div>
</div> 
</template>

<script>
import DealerCode from '@/components/Search/dealerCode.vue';
import dropDown from './dropDown/dropDown.vue';
import Datepicker from 'vuejs-datepicker';
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'search',
    props: {
        dealerCodes: {
            type: Array,
            required: false,
            default: null
        },
        searchCriteria: {
            type: Object,
            required: true
        },
        language: {
            type: String,
            default: 'en'
        }
    },
    components: {
        DealerCode,
        Datepicker,
        dropDown
    },
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            resetTrigger: {
                dealerCode: false,
                reportCode: false,
                reportId: false,
                reportTypeId: false,
                reportFrequencyId: false
            },
            searches: {
                'dealerCode': null,
                'reportId': null,
                'reportCode': null,
                'reportTypeId': null,
                'reportFrequencyId': null,
                'startDate': null,
                'endDate': null,
                'keyword': null             
            },            
            latestSearch: {},
            daysAgo: -1
        }
    },
    methods: {
        init: function(){
            
        },
        dateChange: function(dateType){
            var value = this.searches[dateType];
            if(value){
                this.latestSearch = {};
                // this.resetSearch(dateType);
            }
            this.daysAgo = -1;
        },
        selection: function(data){
            this.searches[data.name] = data.selection;

            if(data.selection!=null){
                this.latestSearch = {};
                this.latestSearch[data.name] = data.selection;
                // this.resetSearch(data.name);
            }
        },
        selectedDealerCode: function(data){
            this.searches.dealerCode = data.selection;
            this.$emit('selectedDealerCode',data);
        },
        resetSearch: function(exception=null){
            var self = this;
            this.daysAgo = -1;

            for(let i in this.resetTrigger){
                if(i!=exception){
                    this.resetTrigger[i] = true;
                }
            }

            for(let i in this.searches){
                var part_1 = (exception=='startDate' || exception=='endDate');
                var part_2a = (i=='startDate' && this.searches.startDate!=null);
                var part_2b = (i=='endDate' && this.searches.endDate!=null);
                if( i=='dealerCode' || (part_1===true && (part_2a || part_2b))  ){
                    /* DO NOTHING */
                }else{
                    this.searches[i] = null;
                }
            }

            setTimeout(function(){
                for(let i in self.resetTrigger){
                    self.resetTrigger[i] = false;
                }
            },200);



            if(exception===null){
                this.latestSearch = {};
                // this.applySearch();
            }            
        },
        applySearch: function(){
            var self = this;
            // var data = {};

            // if(this.objectLength(this.latestSearch)==0){
            //     if(this.searches.startDate){
            //         data.startDate = this.searches.startDate;
            //     }
    
            //     if(this.searches.endDate){
            //         data.endDate = this.searches.endDate;
            //     }

            // }else{
            //     data = this.latestSearch;
            // }

            var data = {}
            for(let i in  self.searches){
                var search = self.searches[i];   
                if (search!=null && typeof search === 'string'){                     
                    if(search.trim()=='') search = null; 
                }       
                if(search!=null){
                    data[i] = search;
                }
            }
            this.category=null;
            this.$emit('search',data);

        },
        selectDaysInPast(daysInPast) {
            // user clicked same date, so remove it
            if(this.daysAgo==daysInPast) {
                this.daysAgo = -1;
                this.searches.startDate = null;
                this.searches.endDate = null;
            }
            else {
                this.daysAgo = daysInPast;
                var past = Date.now() - daysInPast*24*60*60*1000;
                var date = new Date(past);
                this.searches.startDate = date;
                this.searches.endDate = date;
            }
        },
        label: function(key){
            return this.$Localization.str(key);
        },
        objectLength: function(obj){
            return Object.keys(obj).length;
        },
        allowSearch: function(){
            return  (this.allowDealerCode && this.searches.dealerCode!=null) || (!this.allowDealerCode && this.itemsSet(this.searches)>0)
        },
        itemsSet: function(obj){
            var counter = 0;
            for(let i in obj){
                if(obj[i]!=null){
                    counter++;
                }
            }
            return counter;
        },
        disabledStartDate: function() {
            var data = {
                from: new Date()
            }
            if(this.searches.endDate) {
                data.from = this.searches.endDate;
            }
            return data;
        },
        disabledEndDate: function() {
            var data = {
                from: new Date()
            }
            if(this.searches.startDate) {
                data.to = this.searches.startDate;
            }
            return data;
        }
    },
    computed: {
        calendarLang: function() {
            return this.language=='fr' ? fr : en;
        },
        allowDealerCode: function(){
            return this.$application.allowDealerCodes();
        },
        records: function(){
            var searchCriteria = this.searchCriteria;

            var list = ['names','dealerCodes','reportCodes','reportFrequencies','reportTypes','reportTypeFreqMapping'];

            var records = {};

            for(var l=0; l<list.length; l++){
                var item = list[l];
                records[item] = this.$Localization.objStr(searchCriteria,item);
            }
            
            return records;
        },
        list_report_names: function(){
            if(this.searches.reportTypeId && !this.searches.reportFrequencyId){
                var filterRptNames = [];
                var filterRptIds = [];               
                for(let i=0; i < this.records.reportTypeFreqMapping.length; i++){
                    var typeMap = this.records.reportTypeFreqMapping[i];
                    var index = typeMap.mapId.indexOf("|");
                    var typeId = parseInt(typeMap.mapId.substring(0, index));                       
                    if(typeId == this.searches.reportTypeId){
                            filterRptIds.push(typeMap.id);
                    }	 
                }                
                for(let i=0; i < this.records.names.length; i++){                
                   if(filterRptIds.includes(this.records.names[i].id)){
                        filterRptNames.push(this.records.names[i]);
                   }
				}    
                return  filterRptNames;          
            }else if(this.searches.reportFrequencyId && !this.searches.reportTypeId){
                var filterRptNameList = [];
                var filterRptIdList = [];
                for(let i=0; i < this.records.reportTypeFreqMapping.length; i++){
                    var typeFreqMap = this.records.reportTypeFreqMapping[i];
                    var indx = typeFreqMap.mapId.indexOf("|");
                    var freqId = parseInt(typeFreqMap.mapId.substring(indx+1));                      
                    if(freqId == this.searches.reportFrequencyId){
                            filterRptIdList.push(typeFreqMap.id);
                    }	 
                }               
                for(let i=0; i < this.records.names.length; i++){                
                   if(filterRptIdList.includes(this.records.names[i].id)){
                       filterRptNameList.push( this.records.names[i]);
                   }
				}    
                return  filterRptNameList;
            }else if(this.searches.reportTypeId && this.searches.reportFrequencyId){
                var filterRptNameArray = [];
                var filterRptIdArray = [];               
                for(let i=0; i < this.records.reportTypeFreqMapping.length; i++){
                    var typeMap1 = this.records.reportTypeFreqMapping[i];
                    var index1 = typeMap1.mapId.indexOf("|");
                    var typeId1 = parseInt(typeMap1.mapId.substring(0, index1)); 
                    var freqId1 = parseInt(typeMap1.mapId.substring(index1+1));                         
                    if(typeId1 == this.searches.reportTypeId && freqId1==this.searches.reportFrequencyId){
                            filterRptIdArray.push(typeMap1.id);
                    }	 
                }                
                for(let i=0; i < this.records.names.length; i++){                
                   if(filterRptIdArray.includes(this.records.names[i].id)){
                        filterRptNameArray.push(this.records.names[i]);
                   }
				}    
                return  filterRptNameArray;
            }else{
                return this.records.names;
            }
        },
        list_report_codes: function(){
            var list = [];
            for(let i=0; i<this.records.reportCodes.length; i++){
                var code = this.records.reportCodes[i];
                list.push({
                    id: code,
                    name: code
                })
            }
            return list;
        },
        list_report_types: function(){
            var typeId = 0;           
            var selectedRptId = this.searches.reportId;
            if(this.searches.reportId) {
                var typeFreqMap = this.records.reportTypeFreqMapping.filter(function(mapp) {
                    return mapp.id === selectedRptId;
                });               
                var index = typeFreqMap[0].mapId.indexOf("|");
                typeId = parseInt(typeFreqMap[0].mapId.substring(0, index));

                var rptTypes = [];   
                this.records.reportTypes.filter(function(rptType) {return rptType.id===typeId;}).forEach((rptType) => {
					rptTypes.push(rptType);
				});                
                return rptTypes;
            }else if(this.searches.reportFrequencyId){               
                var rptTypeList = [];          
                for(let k=0; k < this.list_report_names.length; k++){
                      var rptId = this.list_report_names[k].id;
                      var typeFreqMapping = this.records.reportTypeFreqMapping.filter(function(mapp) {
                          return mapp.id ===  rptId;
                      });               
                      var indx = typeFreqMapping[0].mapId.indexOf("|");
                      var rptTypeId = parseInt(typeFreqMapping[0].mapId.substring(0, indx));                   
                      this.records.reportTypes.filter(function(rptType) {return rptType.id===rptTypeId;}).forEach((rptType) => {
                          if(!rptTypeList.includes(rptType)){
                              rptTypeList.push(rptType);
                          }
                        }); 
                }               
                return rptTypeList;
            }else{   
                return this.records.reportTypes;
            }
        },
        list_report_frequencies: function(){
            var freqId = 0;           
            var selectedRptId = this.searches.reportId;
            if(this.searches.reportId) {
                var typeFreqMap = this.records.reportTypeFreqMapping.filter(function(mapp) {
                    return mapp.id === selectedRptId;
                });               
                var index = typeFreqMap[0].mapId.indexOf("|");
                freqId = parseInt(typeFreqMap[0].mapId.substring(index+1));

                var rptFreqs = [];   
                this.records.reportFrequencies.filter(function(rptFrequ) {return rptFrequ.id===freqId;}).forEach((rptFrequ) => {
					rptFreqs.push(rptFrequ);
				});                
                return rptFreqs;
            }else if(this.searches.reportTypeId){
                var rptFreqId = 0; 
                var rptFreqList = [];  
                var filterRptNames = [];
                var filterRptIds = [];               
                for(let i=0; i < this.records.reportTypeFreqMapping.length; i++){
                    var typeMap = this.records.reportTypeFreqMapping[i];
                    var indece = typeMap.mapId.indexOf("|");
                    var typeId = parseInt(typeMap.mapId.substring(0, indece));                       
                    if(typeId == this.searches.reportTypeId){
                            filterRptIds.push(typeMap.id);
                    }	 
                }                
                for(let i=0; i < this.records.names.length; i++){                
                   if(filterRptIds.includes(this.records.names[i].id)){
                        filterRptNames.push(this.records.names[i]);
                   }
				}                 
                for(let k=0; k < filterRptNames.length; k++){
                  var selectRptId =  filterRptNames[k].id;  
                  var typeFreqMapping = this.records.reportTypeFreqMapping.filter(function(mapp) {
                    return mapp.id === selectRptId;
                  });               
                  var indx = typeFreqMapping[0].mapId.indexOf("|");
                  rptFreqId = parseInt(typeFreqMapping[0].mapId.substring(indx+1));
                  this.records.reportFrequencies.filter(function(rptFrequ) {return rptFrequ.id===rptFreqId;}).forEach((rptFrequ) => {
                      if(!rptFreqList.includes(rptFrequ)){
                         rptFreqList.push(rptFrequ);
                      }
                    });                  
               }
               return rptFreqList;
            }else{   
                return this.records.reportFrequencies;
            }   
        },
        list_dealer_codes: function(){
            var list = [];
            for(let i=0; i<this.records.dealerCodes.length; i++){
                var code = this.records.dealerCodes[i];
                list.push({
                    id: code,
                    name: code
                })
            }
            return list;
        },
        ready_to_search: function(){
            return this.allowSearch();
        }

    }

}
</script>



<style module>
.title{
    border-bottom: 1px solid lightgrey;
    margin-bottom: 15px;
    font-size: 0.8em;
    text-align: center;
}

input, select{
    border: 1px solid lightgrey;
    border-radius: 3px;
}

.buttons{
    position: relative;
    width: 100%;
    margin: 0 auto;
    height: 30px;
}
@media screen and (max-width: 1024px) {
    .buttons {
        width: 80%;
    }
}

.searches{
    text-align: left;
    border: 1px solid #eee;
    padding: 12px;
    border-radius: 10px;
}

fieldset{
    border: 1px solid lightgrey;
    padding: 15px 3px 15px 3px;
    margin: 10px 0px 25px 0px;
    border-radius: 3px;
}
fieldset input{
    width: 118px;
    font-size: 0.8em;
}

fieldset legend{
    font-weight: 400;
    font-size: 1em;
}

.dropDown{
    display: block;
}

.keyword{
    width: 100%;
    margin-bottom: 10px;
    display: block;
}

.label{
    font-size: 1em;
}

.dateButtons {
    margin-top: 15px;
}
.dateButtons button {
    margin: 3px 5px;
    background: #ddd;
    color: darkslategrey;
    width: 45%;
}
.dateButtons button.active {
    background: #444;
    color: white;
}

button{
    transition: 0.4;
}

button:active{
    color: darkslategrey;
}

button:hover{
    opacity: 0.8;
}

button:focus{
    outline: none;
}

</style>

<style>
    .vdp-datepicker {
        display: inline-block;
        margin: 2px;
    }
    .vdp-datepicker input {
        max-width: 100px;
        text-align: center;
        font-weight: bold;
        font-size: 0.8em;
    }
</style>